import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchdaySlider from '../MatchdaySlider';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class CopaChile2011 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [666,667,668,669,670,671,678,679,685,686];
    this.state = {
	showCards: true,
	        maxMatchday: 6,
      color2:['#135683','#135683','#135683','#135683','#135683','#135683','#135683','#135683',0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
	kit_path: '/images/kits/todas/',
      kits: [],
      path: this.props.path,
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,
	table2: []
/*	table2:[{'color':0,'shortname':'cobreloa', 'rivalName':'Cobreloa', 'pj':6, 'pg':1,'pe':2,'pp':3,'gf':5,'gc':9,'dif':-4, 'pts':5},
              {'color':'#135683','shortname':'audax', 'rivalName':'Audax Italiano', 'pj':6, 'pg':5,'pe':1,'pp':0,'gf':19,'gc':5,'dif':14, 'pts':16},
	     {'color':'#135683','shortname':'morning', 'rivalName':'S. Morning', 'pj':6, 'pg':5,'pe':1,'pp':0,'gf':8,'gc':3,'dif':5, 'pts':16},
              {'color':'#135683','shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':6, 'pg':4,'pe':2,'pp':0,'gf':9,'gc':2,'dif':7, 'pts':14},
	      {'color':'#135683','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':6, 'pg':4,'pe':1,'pp':1,'gf':14,'gc':7,'dif':7, 'pts':13},
              {'color':'#135683','shortname':'catolica', 'rivalName':'U. Católica', 'pj':6, 'pg':4,'pe':2,'pp':0,'gf':9,'gc':0,'dif':9, 'pts':14},
              {'color':0,'shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':6, 'pg':2,'pe':2,'pp':2,'gf':9,'gc':9,'dif':0, 'pts':8},
              {'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pj':6, 'pg':4,'pe':0,'pp':2,'gf':10,'gc':7,'dif':3, 'pts':12},
              {'color':'#135683','shortname':'huachipato', 'rivalName':'Huachipato', 'pj':6, 'pg':5,'pe':0,'pp':1,'gf':18,'gc':5,'dif':13, 'pts':15},
              {'color':0,'shortname':'udechile', 'rivalName':'U. de Chile', 'pj':6, 'pg':4,'pe':1,'pp':1,'gf':6,'gc':4,'dif':2, 'pts':13},
              {'color':0,'shortname':'lacalera', 'rivalName':'U. La Calera', 'pj':6, 'pg':2,'pe':3,'pp':1,'gf':5,'gc':5,'dif':0, 'pts':9},
              {'color':0,'shortname':'nublense', 'rivalName':'Ñublense', 'pj':6, 'pg':3,'pe':1,'pp':2,'gf':4,'gc':5,'dif':-1, 'pts':10},
              {'color':0,'shortname':'union', 'rivalName':'U. Española', 'pj':6, 'pg':4,'pe':0,'pp':2,'gf':15,'gc':3,'dif':12, 'pts':12},
              {'color':0,'shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':6, 'pg':1,'pe':2,'pp':3,'gf':7,'gc':9,'dif':-2, 'pts':5},
	      {'color':'#135683','shortname':'laserena', 'rivalName':'La Serena', 'pj':6, 'pg':4,'pe':1,'pp':1,'gf':11,'gc':5,'dif':6, 'pts':13},
	      {'color':0,'shortname':'sanfelipe', 'rivalName':'U. San Felipe', 'pj':6, 'pg':0,'pe':2,'pp':4,'gf':2,'gc':6,'dif':-4, 'pts':2},
              {'color':'#135683','shortname':'magallanes', 'rivalName':'Magallanes', 'pj':6, 'pg':4,'pe':2,'pp':0,'gf':12,'gc':3,'dif':9, 'pts':14},
	      {'color':0,'shortname':'rangers', 'rivalName':'Rangers', 'pj':6, 'pg':3,'pe':2,'pp':1,'gf':15,'gc':8,'dif':7, 'pts':11},
              {'color':0,'shortname':'utemuco', 'rivalName':'U. Temuco', 'pj':6, 'pg':3,'pe':1,'pp':2,'gf':11,'gc':6,'dif':5, 'pts':10},
              {'color':0,'shortname':'curico', 'rivalName':'Curicó Unido', 'pj':6, 'pg':3,'pe':0,'pp':3,'gf':4,'gc':6,'dif':-2, 'pts':9},
              {'color':0,'shortname':'puertomontt', 'rivalName':'Puerto Montt', 'pj':6, 'pg':3,'pe':0,'pp':3,'gf':8,'gc':16,'dif':-8, 'pts':9},
              {'color':0,'shortname':'concepcion', 'rivalName':'Dep. Concepción', 'pj':6, 'pg':2,'pe':2,'pp':2,'gf':10,'gc':8,'dif':2, 'pts':8},
              {'color':0,'shortname':'everton', 'rivalName':'Everton', 'pj':6, 'pg':1,'pe':5,'pp':0,'gf':6,'gc':4,'dif':2, 'pts':8},
              {'color':0,'shortname':'arica', 'rivalName':'San Marcos Arica', 'pj':6, 'pg':2,'pe':2,'pp':2,'gf':6,'gc':5,'dif':1, 'pts':8},
              {'color':0,'shortname':'lota', 'rivalName':'Lota Schwager', 'pj':6, 'pg':2,'pe':2,'pp':2,'gf':8,'gc':11,'dif':-3, 'pts':8},
              {'color':0,'shortname':'coquimbo', 'rivalName':'Coquimbo', 'pj':6, 'pg':2,'pe':1,'pp':3,'gf':9,'gc':12,'dif':-3, 'pts':7},
              {'color':0,'shortname':'sanluis', 'rivalName':'San Luis', 'pj':6, 'pg':1,'pe':3,'pp':2,'gf':4,'gc':5,'dif':-1, 'pts':6},
              {'color':0,'shortname':'temuco', 'rivalName':'Dep. Temuco', 'pj':6, 'pg':1,'pe':2,'pp':3,'gf':7,'gc':10,'dif':-3, 'pts':5},
              {'color':0,'shortname':'mejillones', 'rivalName':'Mejillones', 'pj':6, 'pg':1,'pe':2,'pp':3,'gf':6,'gc':10,'dif':-4, 'pts':5},
              {'color':0,'shortname':'copiapo', 'rivalName':'Dep. Copiapó', 'pj':6, 'pg':1,'pe':0,'pp':5,'gf':4,'gc':10,'dif':-6, 'pts':3},
              {'color':0,'shortname':'naval', 'rivalName':'Naval', 'pj':6, 'pg':0,'pe':1,'pp':5,'gf':2,'gc':9,'dif':-7, 'pts':1},
              {'color':0,'shortname':'enfoque', 'rivalName':'Enfoque', 'pj':6, 'pg':0,'pe':1,'pp':5,'gf':5,'gc':22,'dif':-17, 'pts':1},
              {'color':0,'shortname':'kumey', 'rivalName':'Quesos Kumey', 'pj':6, 'pg':0,'pe':0,'pp':6,'gf':4,'gc':18,'dif':-14, 'pts':0},
              {'color':0,'shortname':'lapintana', 'rivalName':'La Pintana', 'pj':6, 'pg':0,'pe':0,'pp':6,'gf':2,'gc':20,'dif':-18, 'pts':0},
              {'color':0,'shortname':'palestino', 'rivalName':'Palestino', 'pj':6, 'pg':0,'pe':2,'pp':4,'gf':7,'gc':13,'dif':-6, 'pts':2},
              {'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':6, 'pg':2,'pe':1,'pp':3,'gf':5,'gc':6,'dif':-1, 'pts':7}]
*/
    };
  }

  componentDidMount() {
	this.getKits();
	this.getStandings();
	}



generateTable(fixture, json){

let result = [];
const lastTable = json[fixture].table;
console.log(lastTable);
lastTable.forEach(team => {
  console.log(team.team, team.points);
  result.push({
    shortname: team.name,
    pj: team.played,
    pg: team.won,
    pe: team.drawn,
    pp: team.lost,
    gf: team.goals_for,
    gc: team.goals_against,
    dif: team.goal_difference,
    pts: team.points,
    rivalName: team.team
  });
});

return result;



}

handleMatchdayChange = (day) => {
    console.log("Selected matchday:", day);



        let newtable2 = this.generateTable(day-1,this.state.standings);

        let sortednewtable2 = this.sortTable(newtable2);


        for (let i = 0; i < sortednewtable2.length; i++) {
                sortednewtable2[i].color = this.state.color2[i]; 
        }
        this.setState({table2:sortednewtable2});


  };


getStandings(){

        fetch("https://www.registrosudec.com:5000/standings", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: 32
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)

        let standingsObj = result['standings'];
        let regular = standingsObj[0];
        console.log("regular");
        console.log(regular);
        this.setState({ 
        standings: regular['standings_history']}) //[json1, json2,...]
        let newtable2 = this.generateTable(5,regular['standings_history']);

        let sortednewtable2 = this.sortTable(newtable2);


        for (let i = 0; i < sortednewtable2.length; i++) {
                sortednewtable2[i].color = this.state.color2[i]; 
        }
        this.setState({table2:sortednewtable2});



    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}


getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", soc$
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}


  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={3} xl={3} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color} style={{width:'20px'}}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){

let subC = this.subText('#135683', 'Clasificado a Cuartos de Final');
  return(

	<div style={{textAlign: 'center' }}>

	<div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Copa Chile 2011</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>


	        <div style={{ height: '50px' }}></div>
        <div>
        <span>Evolución de la tabla</span>
      <MatchdaySlider maxMatchday={this.state.maxMatchday} onChange={this.handleMatchdayChange} />
    </div>



	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
         {subC}
	 
	
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Copa Chile 2011</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Copa Chile 2011</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Copa Chile 2011" />
     </div>


  )
}

}
export default CopaChile2011;
